<template>
  <component
    :is="tag"
    class="dropdown"
    :class="{show:isOpen}"
    @click="toggleDropDown"
    v-click-outside="closeDropDown">
    <a class="dropdown-toggle btn-rotate custom-a btn-outline-success"
       :class="titleClasses"
       data-toggle="dropdown">
      <slot name="title">
      </slot>
      <slot name="title2">
        {{trans.actions.actions}}
      </slot>
    </a>
    <ul class="dropdown-menu dropdown-menu-custom" :class="{show:isOpen}">
      <slot name="actions"></slot>
    </ul>
  </component>
</template>
<script>
export default {
  props: {
    tag: {
      type: String,
      default: "li"
    },
    title: String,
    icon: String,
    titleClasses: [String, Object, Array]
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleDropDown() {
      this.isOpen = !this.isOpen;
      this.$emit("change", this.isOpen);
    },
    closeDropDown() {
      this.isOpen = false;
      this.$emit('change', false);
    }
  },
  computed: {
    trans() {
      return this.$store.getters.GET_TRANS;
    }
  },
};
</script>

<style>
.dropdown {
  display: inline-block !important;
  position: relative !important;
}
.custom-a {
  border: 1px solid #6c757d;
  border-radius: 5px;
  color: #6c757d;
}
.dropdown-menu-custom {
  padding: 9px !important;
  box-shadow: 0 0 8px 1px #000000bf !important;
}
.dropdown-menu-custom li a {
  width: 100%;
  margin-bottom: 8px;
}
</style>
